"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "transformer", {
    enumerable: true,
    get: function() {
        return transformer;
    }
});
var _transformerere = /*#__PURE__*/ _interop_require_wildcard(require("./transformerere/transformerere"));
var _transformerFelt = require("./transformerFelt");
var _transformerHeader = require("./transformerHeader");
var _transformerSteg = require("./transformerSteg");
var _enReferanse = require("./transformerere/enReferanse");
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interop_require_wildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) {
        return obj;
    }
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
        return {
            default: obj
        };
    }
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) {
        return cache.get(obj);
    }
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj){
        if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
            var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
            if (desc && (desc.get || desc.set)) {
                Object.defineProperty(newObj, key, desc);
            } else {
                newObj[key] = obj[key];
            }
        }
    }
    newObj.default = obj;
    if (cache) {
        cache.set(obj, newObj);
    }
    return newObj;
}
// DISSE ER DUPLISERT OGSÅ I VISNINGSDEFINISJONER-OG-TEKSTER
var headerId = function(id) {
    return "header.".concat(id);
};
var subheaderId = function(id) {
    return "subheader.".concat(id);
};
var transformerFeltMedAlleTransformers = (0, _transformerFelt.transformerFelt)(_transformerere);
var transformerHeaderMedAlleTransformers = (0, _transformerHeader.transformerHeader)(transformerFeltMedAlleTransformers);
var transformerStegMedAlleTransformers = (0, _transformerSteg.transformerSteg)(_transformerere);
var transformer = {
    transformerFelt: transformerFeltMedAlleTransformers,
    transformerHeader: transformerHeaderMedAlleTransformers(headerId),
    transformerSubHeader: transformerHeaderMedAlleTransformers(subheaderId),
    erNumerisk: function(t) {
        return t && [
            "tall",
            "stortTall",
            "desimaltall",
            "prosent",
            "positivtTall"
        ].includes(t.id);
    },
    transformerSteg: transformerStegMedAlleTransformers,
    transformerTall: _enReferanse.formaterNummer
};
